import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const TikTokCallback = lazy(() => import("@/pages/TikTokCallback"));

export const Route = createFileRoute("/api/tiktok/callback")({
  component: TikTokCallback,
});
